import { Button, Card, Title } from "../../components/UI";
import { CompanyDescription, Container } from "../../styles/pages/company-quests";
import { Divisor } from "../../styles/pages/quests/styles";
import { useEffect, useState } from "react";
import CompanyQuests from "../../components/Quests/CompanyQuests";
import Head from 'next/head';
import { useRouter } from "next/router";
import { useQuests, getQuestCompanyBySlug, refreshQuestOnExtension } from "../../hooks/quests";
import { QuestCompany } from "../../models/quests";
import { GetServerSidePropsContext } from "next";
import { t } from "i18next";

interface Props {
  quest_company?: QuestCompany;
}

export async function getServerSideProps(context: GetServerSidePropsContext) {

  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=30, stale-while-revalidate=59'
  );

  const { company_slug } = context.params;

  if(context.req.url && !context.req.url.startsWith('/_next/data')) {

    const quest_company = await getQuestCompanyBySlug(company_slug as string);

    if (!quest_company) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        quest_company
      },
    };
  } else {
    return {
      props: {},
    };
  }
};

const CompanyQuestsPage: React.FC<Props> = ({ quest_company }) => {

  const router = useRouter();
  const { company_slug } = router.query;

  const { getQuestCompanyBySlug } = useQuests();
  const [ questCompany, setQuestCompany ] = useState<QuestCompany|null>(quest_company);
  const [ showUnauthenticatedMessage, setShowUnauthenticatedMessage ] = useState<boolean>(false);

  useEffect(() => {
    if (!company_slug) {
      return;
    }

    refreshQuestOnExtension();

    async function getInitialData() {
      try {
        const company = await getQuestCompanyBySlug(company_slug as string);
        setQuestCompany(company);
      } catch (error) {}
    }

    getInitialData();

    setShowUnauthenticatedMessage(
      localStorage.getItem('@coingoback:token') ? false : true
    );

  }, [company_slug]);

  return (
    <>
      <Head>
        <title>{t('pages.quests.earn-bitcoin-by-completing-quests-of')} {questCompany?.name ?? ''} | Cointimes</title>
        <meta
          name="description"
          content={questCompany?.description ?? ''}
        />
      </Head>
      <Container>
        <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'flex-start', gap: 10}}>
          <Title>{questCompany?.name ?? ''}</Title>
          <CompanyDescription>{questCompany?.description ?? ''}</CompanyDescription>

          {showUnauthenticatedMessage ? (
          <>
            <Divisor/>
            <div style={{display: 'flex', flexDirection: 'column', padding: 50, alignItems: 'center', gap: 20, width: '100%'}}>
              <span>{t('pages.quests.to-complete-quests-and-earn-bitcoin-log-in-and-install-the-extension')}.</span>
              <div style={{display: 'flex', gap: 20}}>
                <a href='/login'>{t('pages.quests.sign-in')}</a>
                <a style={{color: '#FF5600', fontWeight: 700}} href='/signup'>{t('pages.quests.create-account')}</a>
              </div>
            </div>
            </>) : (null)}
          <Divisor/>
          <CompanyQuests company_slug={company_slug as string} />
        </div>
        <Card.Box dark className='extensionCard'>
          <Card.Text style={{color: '#FFF', textAlign: 'center'}}>{t('pages.quests.install-extension-message')}</Card.Text>
          <a 
            href="https://chrome.google.com/webstore/detail/cointimes/cbohbbfalnakfabmclapcglchjnpljdm"
            target="_blank"
          >
            <Button>{t('pages.quests.install-extension')}</Button>
          </a>
        </Card.Box>
      </Container>
    </>
  );
};

export default CompanyQuestsPage;
